import React from 'react';
import moment from 'moment';
import { CSVLink } from "react-csv";

"id", "amount", "createdAt", "description", "label", "note"

const headers = [
    { label: 'id', key: 'id' },
    { label: 'amount', key: 'amount' },
    { label: 'date', key: 'createdAt' },
    { label: "description", key: "description" },
    { label: "label", key: "label" },
    { label: "note", key: "note" }
]

// const formatDownload = (expenses) => {
//     console.log("preparedownload")
//     let copyExpenses = [...expenses]
//     let i = 1;
//     let frmtExpenses = []
//     const newExpense = copyExpenses.map((expense) => {
//         expense.id = i++;
//         expense.amount = expense.amount / 100;
//         expense.createdAt = moment(expense.createdAt).format('MM/DD/YYYY')
//         return expense
//     })
//     return newExpense

// }

const formatDownload2 = (expenses) => {
    console.log("preparedownload")
    let i = 1;
    let frmtExpenses = []
    let expenseObj = {}
    let clonedExpenses = JSON.parse(JSON.stringify(expenses))
    //console.log("cloned Expenses: ", clonedExpenses)
    expenses.map((expense) => {
        expenseObj = {
            id: i++,
            amount: (expense.amount / 100).toFixed(2),
            createdAt: moment(expense.createdAt).format('MM/DD/YYYY'),
            description: expense.description,
            label: expense.label,
            note: expense.note

        }
        //i++;
        frmtExpenses.push(expenseObj)

        //return expense
    })
    return frmtExpenses

}

const formatDownload4 = ((expenses) => {
    console.log("preparedownload4")
    const clonedExpenses = [...expenses]


    let i = 1;
    const newExpenses = clonedExpenses.map((expense) => {
        expense.id = i++;
        expense.amount = expense.amount / 100;
        expense.createdAt = moment(expense.createdAt).format('MM/DD/YYYY')
        return expense
    })

    return newExpenses



})

const formatDownload3 = (expenses) => {
    //console.log("preparedownload")
    let clonedExpenses = JSON.parse(JSON.stringify(expenses))
    let i = 1;
    clonedExpenses.map((expense) => {
        expense.id = i++;
        expense.amount = expense.amount / 100;
        expense.createdAt = moment(expense.createdAt).format('MM/DD/YYYY')
        return expense
    })

    return clonedExpenses

}



// const _formatDownload3 = (expenses) => {
//     console.log("preparedownload")
//     //let copyExpenses = [...expenses]
//     let i = 1;
//     let frmtExpenses = []
//     let expenseObj = {}
//     let clonedExpenses = JSON.parse(JSON.stringify(expenses))
//     console.log("cloned Expenses: ", clonedExpenses)
//     expenses.map((expense) => {
//         expenseObj = {
//             id: i++,
//             amount: (expense.amount / 100).toFixed(2),
//             createdAt: moment(expense.createdAt).format('MM/DD/YYYY'),
//             description: expense.description,
//             label: expense.label,
//             note: expense.note

//         }
//         //i++;
//         frmtExpenses.push(expenseObj)

//         //return expense
//     })
//     return frmtExpenses

// }




const onDownload = (exp) => {
    console.log("On Download Handler ", exp)
}

const Download = ({ expenses = [], downloadFilename = `expenses-${moment().format('YYYYMMDD')}_${moment().format('HHmmss')}.csv` }) => (

    expenses.length > 0 ? (

        < CSVLink
            data={formatDownload3(expenses)}
            headers={headers}
            filename={downloadFilename}
            separator={","}
            enclosingCharacter={`"`}
            className="button--download"
            target="_blank"
            onClick={() => {
                //onDownload(expenses)
                return true

            }}

        >
            Download

        </CSVLink >
    ) :
        (

            <div>&nbsp;</div>
        )




);

export default Download;




// WEBPACK FOOTER //
// ./src/components/Download.js